module.exports = __webpack_public_path__ + "img/album08_07.cc20b729.jpg";